import EmptyValuePlaceholder from '../EmptyValuePlaceholder'

export default ({ 
  label, value, children, 
  className = "", 
  labelClassName = "", valueClassName = "",
  forceEmptyPlaceholder = false
}) => (
  <div className={ className || "flex flex-wrap items-center mb-2"}>
    <label className={`block text-sm font-medium text-gray-600 mr-2 ${labelClassName}`}>
      {label} :
    </label>
    <div className={`mx-1 ${valueClassName}`}>
      { forceEmptyPlaceholder && !value && <EmptyValuePlaceholder /> }
      { children || <EmptyValuePlaceholder value={value} /> }
    </div>
  </div>
)